import { render, staticRenderFns } from "./LoginAdminView.vue?vue&type=template&id=accb9a50&"
import script from "./LoginAdminView.vue?vue&type=script&lang=js&"
export * from "./LoginAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports